import { FieldTitle } from '../common/index';
import React from 'react';

function Label(props) {
  const { internalTitle, options, formId, className } = props;
  const contentArticleFormId = `content_article_form-${props.contentArticleFormId}`;
  const forId = `${contentArticleFormId}-${FieldTitle.titleFor(internalTitle, formId)}`;

  return (
    <div className={className}>
      <label htmlFor={forId}>{options.value}</label>
    </div>
  );
}

Label.propTypes = {
  options: React.PropTypes.object,
  internalTitle: React.PropTypes.string,
  formId: React.PropTypes.number,
  contentArticleFormId: React.PropTypes.number,
  className: React.PropTypes.string
};

Label.defaultProps = {
  className: 'formgroup'
};

export default Label;



// WEBPACK FOOTER //
// ./components/forms/label.js